import React, { cloneElement, useEffect } from 'react';
import { useLocation } from 'react-router';

import { AppHeader } from '~/components/app-header/AppHeader';
import { ChatInput, ChatInputProps } from '~/components/chat';
import { useTouchDevice } from '~/hooks/MediaQueryHook';
import { mobileAlfredPaths } from '~/Root';
import { AppRoute } from '~/routes';
import { appPaths } from '~/routes/app-paths';
import { useSubscription } from '~/stores/use-subscription/useSubscription';
import { useReasonerParams } from '~/views/alfred/research/hooks/useReasonerParams';
import { useChatNavigation } from '~/views/alfred/use-chat-navigation/useChatNavigation';
import { MarketInsightDrawerRender } from '~/views/dashboard/whats-new-widget/components/market-insight-drawer/MarketInsightDrawerRender';
import { InsightsFullDrawerRender } from '~/views/insights/components/insights-full-drawer/InsightsFullDrawerRender';
import { Widgets } from '~/views/widgets/Widgets';
import { CompanyCatalystDrawer } from '~/widgets/catalyst-insights-drawer/catalyst-drawer-header/company-catalyst-drawer/CompanyCatalystDrawer';
import { EarningsInsightDrawer } from '~/widgets/earnings-insight-drawer/EarningsInsightDrawer';
import { InsightsDrawerRender } from '~/widgets/insight-widget/components/insight-drawer/InsightsDrawerRender';
import { MarketCatalystDrawer } from '~/widgets/market-catalyst-drawer/MarketCatalystDrawer';

import { checkIsMobile } from '../ProtectedView';
import * as S from './View.styles';

export interface AccountViewProps {
  config: AppRoute;
  showHeader: boolean;
}

export const View = ({ config, showHeader }: AccountViewProps) => {
  const location = useLocation();
  const isTouchDevice = useTouchDevice();
  const isBasicOrLightUser = useSubscription(state =>
    state.isBasicOrLightUser()
  );

  const { navigateToConversation } = useChatNavigation();
  const { conversationId } = useReasonerParams();

  const { element } = config;

  const content = cloneElement(element, {
    renderChatInput: (props?: ChatInputProps) => <ChatInput {...props} />,
  });

  const isMobileAlfredPath =
    mobileAlfredPaths.includes(location.pathname) && isTouchDevice;

  useEffect(() => {
    if (checkIsMobile() && location.pathname !== appPaths.alfred) {
      navigateToConversation(conversationId);
    }
  }, [conversationId, isTouchDevice, location.pathname]);

  return (
    <>
      {showHeader && !isMobileAlfredPath && <AppHeader />}
      <S.ViewRoot id={'root-view'}>
        {!isMobileAlfredPath && (
          <>
            <Widgets />
            <InsightsDrawerRender />
            <InsightsFullDrawerRender />
            <MarketInsightDrawerRender />
            {!isBasicOrLightUser && <EarningsInsightDrawer />}
            {!isBasicOrLightUser && <CompanyCatalystDrawer />}
            <MarketCatalystDrawer />
          </>
        )}
        {content}
      </S.ViewRoot>
    </>
  );
};
